import multipleSlideshow from './4-multipleSlideshows';

function render(id, opts) {
  multipleSlideshow(id, opts ?? null);
}

export default function renderSlideshows() {
  render(
    'multiSlideshow-one',
    typeof multiSlideshowOneOpts === 'undefined' ? undefined : multiSlideshowOneOpts,
  );

  render(
    'multiSlideshow-two',
    typeof multiSlideshowTwoOpts === 'undefined' ? undefined : multiSlideshowTwoOpts,
  );

  render(
    'multiSlideshow-three',
    typeof multiSlideshowThreeOpts === 'undefined' ? undefined : multiSlideshowThreeOpts,
  );
}
